import React, { useContext } from 'react';
import styled from 'styled-components';
import FontSizeMultiplierContext from '../../components/dashboards/FontSizeMultiplierContext';

const StyledImgIcon = styled.img`
  height: ${props => (props.fontSizeMultiplier / 100) * 16}px;
  width: ${props => (props.fontSizeMultiplier / 100) * 16}px;
  white-space: nowrap !important;
`;

const StyledShortCode = styled.span`
  font-variant: small-caps;
  font-style: normal;
  cursor: default;
  color: white;
  background-color: ${props => (props.htmlColor ? props.htmlColor : '#333')};
  padding: 1px;
  font-size: ${props => (props.fontSizeMultiplier / 100) * 14}px;
  font-weight: bold;
  border-radius: 2px;
  text-shadow: none;
`;

const SkillIcon = ({ skill, className }) => {
  const fontSizeMultiplier = useContext(FontSizeMultiplierContext) || 100;

  if (!skill) return null;

  const icon = skill.icon || {};

  if (icon.present) {
    return (
      <StyledImgIcon
        className={className}
        src={icon.url}
        alt={skill.name}
        title={skill.name}
        fontSizeMultiplier={fontSizeMultiplier}
      />
    );
  } else if (skill.short_code) {
    return (
      <StyledShortCode
        className={className}
        htmlColor={skill.html_color}
        title={skill.name}
        fontSizeMultiplier={fontSizeMultiplier}
      >
        {skill.short_code}
      </StyledShortCode>
    );
  } else {
    return (
      <StyledShortCode
        className={className}
        htmlColor={skill.html_color}
        title={skill.name}
        fontSizeMultiplier={fontSizeMultiplier}
      >
        {skill.name && skill.name.substring(0, 1)}
      </StyledShortCode>
    );
  }
};

export default SkillIcon;
